<template>
  <div>
    <!-- ========== 试剂管理 ========== -->
    <div v-if="activeTab === 'manage'">
        <el-row :gutter="20" class="search-bar">
          <el-col :span="8">
            <el-input v-model="manageSearch.name" placeholder="请输入试剂名称" clearable @keyup.enter="searchManage" />
          </el-col>
          <el-col :span="8">
            <el-input v-model="manageSearch.batchNo" placeholder="请输入批次号" clearable @keyup.enter="searchManage" />
          </el-col>
          <el-col :span="4">
            <el-select v-model="manageSearch.sortOrder" placeholder="排序方向" style="width:100%;" @change="searchManage">
              <el-option label="降序 ↓" value="desc" />
              <el-option label="升序 ↑" value="asc" />
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="searchManage">查询</el-button>
            <el-button type="success" @click="showCreateDialog">新增试剂</el-button>
          </el-col>
        </el-row>

        <el-table :data="manageList" border style="width:100%;margin-top:16px">
          <el-table-column label="序号" width="70">
            <template v-slot="scope">{{ (managePage.current - 1) * managePage.pageSize + scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="试剂名称" min-width="140" />
          <el-table-column prop="specification" label="规格" width="110" />
          <el-table-column prop="batchNo" label="批次号" width="140" />
          <el-table-column label="剩余量" width="110">
            <template v-slot="scope">{{ scope.row.remainAmount }} {{ scope.row.unit }}</template>
          </el-table-column>
          <el-table-column label="总量" width="100">
            <template v-slot="scope">{{ scope.row.totalAmount }} {{ scope.row.unit }}</template>
          </el-table-column>
          <el-table-column prop="manufacturer" label="生产厂家" min-width="130" />
          <el-table-column label="有效期" width="110">
            <template v-slot="scope">
              <span :class="isExpiring(scope.row.expireDate) ? 'text-warning' : ''">{{ scope.row.expireDate || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" fixed="right">
            <template v-slot="scope">
              <div style="display:flex;gap:6px;flex-wrap:wrap;justify-content:center;">
                <el-button size="mini" type="primary" @click="showDetailDialog(scope.row)">详情</el-button>
                <el-button size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
                <el-button size="mini" type="warning" @click="showOutDialog(scope.row)">出库</el-button>
                <el-button size="mini" type="danger" @click="confirmDelete(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination">
          <el-pagination background @size-change="handleManageSizeChange" @current-change="handleManageCurrentChange"
            :current-page="managePage.current" :page-size="managePage.pageSize" :total="managePage.total"
            layout="total, sizes, prev, pager, next, jumper" />
        </div>
      </div>

      <!-- ========== 出库记录 ========== -->
      <div v-if="activeTab === 'record'">
        <el-row :gutter="20" class="search-bar">
          <el-col :span="6">
            <el-input v-model="recordSearch.reagentName" placeholder="请输入试剂名称" clearable @keyup.enter="searchRecord" />
          </el-col>
          <el-col :span="6">
            <el-input v-model="recordSearch.customerName" placeholder="请输入客户名" clearable @keyup.enter="searchRecord" />
          </el-col>
          <el-col :span="6">
            <el-input v-model="recordSearch.customerPhone" placeholder="请输入手机号" clearable @keyup.enter="searchRecord" />
          </el-col>
          <el-col :span="6">
            <el-input v-model="recordSearch.deviceCode" placeholder="请输入设备编码" clearable @keyup.enter="searchRecord" />
          </el-col>
        </el-row>
        <el-row :gutter="20" class="search-bar">
          <el-col :span="8">
            <el-date-picker
              v-model="recordSearch.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              style="width:100%;"
              clearable
            />
          </el-col>
          <el-col :span="6">
            <el-input v-model="recordSearch.operatorName" placeholder="请输入操作人" clearable @keyup.enter="searchRecord" />
          </el-col>
          <el-col :span="10" style="text-align:right;">
            <el-button type="primary" @click="searchRecord">查询</el-button>
          </el-col>
        </el-row>

        <el-table :data="recordList" border style="width:100%;margin-top:16px" :cell-class-name="getRecordCell" class="record-table">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column prop="reagentName" label="试剂名称" min-width="150" class-name="col-reagent-name" />
          <el-table-column label="出库数量" width="110">
            <template v-slot="scope">{{ scope.row.outAmount }}</template>
          </el-table-column>
          <el-table-column prop="operatorName" label="操作人" width="120" />
          <el-table-column prop="outTime" label="出库时间" width="170" />
          <el-table-column prop="remark" label="备注" min-width="180" />
          <el-table-column label="操作" width="90" fixed="right">
            <template v-slot="scope">
              <el-button size="mini" type="warning" @click="confirmRevokeRecord(scope.row)">撤销</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination">
          <el-pagination background @size-change="handleRecordSizeChange" @current-change="handleRecordCurrentChange"
            :current-page="recordPage.current" :page-size="recordPage.pageSize" :total="recordPage.total"
            layout="total, sizes, prev, pager, next, jumper" />
        </div>
      </div>

      <!-- ========== 出库管理 ========== -->
      <div v-if="activeTab === 'out'">
        <!-- 搜索栏 -->
        <el-row :gutter="20" class="search-bar" style="margin-bottom:16px;">
          <el-col :span="7">
            <el-input v-model="quotaSearch.phone" placeholder="按手机号搜索" clearable @keyup.enter="searchQuotaCustomers" />
          </el-col>
          <el-col :span="7">
            <el-input v-model="quotaSearch.userName" placeholder="按客户名搜索" clearable @keyup.enter="searchQuotaCustomers" />
          </el-col>
          <el-col :span="7">
            <el-input v-model="quotaSearch.deviceCode" placeholder="按设备编码搜索" clearable @keyup.enter="searchQuotaCustomers" />
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="searchQuotaCustomers">搜索</el-button>
          </el-col>
        </el-row>

        <!-- 搜索结果表格（选中设备后隐藏） -->
        <el-table
          v-if="!selectedDevice && quotaCustomerList.length > 0"
          v-loading="quotaSearchLoading"
          :data="quotaCustomerList"
          border
          highlight-current-row
          style="margin-bottom:16px;"
          @row-click="selectDevice"
        >
          <el-table-column prop="phone" label="手机号" min-width="130" />
          <el-table-column prop="userName" label="客户名" min-width="110" />
          <el-table-column prop="deviceId" label="设备编码" min-width="150">
            <template v-slot="scope">
              <span style="color:#409eff;font-weight:500;">{{ scope.row.deviceId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceName" label="设备名称" min-width="130">
            <template v-slot="scope">
              <span>{{ scope.row.deviceName || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template v-slot="scope">
              <el-button type="text" size="small">选择</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="!selectedDevice && quotaCustomerList.length === 0 && !quotaSearchLoading && quotaSearched" class="quota-empty-tip">
          未找到设备，请尝试其他关键词
        </div>

        <!-- 已选设备信息卡 -->
        <div v-if="selectedDevice" class="selected-customer-bar">
          <div class="selected-customer-info">
            <span class="sc-label">用户名：</span><span class="sc-name">{{ selectedDevice.userName }}</span>
            <span class="sc-label">手机号：</span><span class="sc-phone">{{ selectedDevice.phone }}</span>
            <span class="sc-label" style="margin-left:12px;">设备名称：</span><span class="sc-name">{{ selectedDevice.deviceName || selectedDevice.deviceId }}</span>
            <span class="sc-label" style="margin-left:8px;">设备编号：</span><span class="sc-phone">{{ selectedDevice.deviceId }}</span>
            <el-tag size="small" type="success" style="margin-left:8px;">已选择</el-tag>
          </div>
          <el-button size="small" type="text" @click="clearDevice">重新选择设备</el-button>
        </div>

        <div v-if="!selectedDevice && !quotaSearched" class="quota-empty-tip">
          请先搜索并选择设备，再为该设备分配试剂额度
        </div>

        <!-- 13种试剂额度调整（始终可见，有设备时启用交互） -->
        <div class="reagent-quota-list" :class="{ 'disabled': !selectedDevice }">
          <div v-if="selectedDevice" class="quota-list-header">
            <span class="qh-index">序号</span>
            <span class="qh-name">试剂名称</span>
            <span class="qh-controls">调整数量</span>
            <span class="qh-current">当前额度</span>
            <span class="qh-change">本次调整</span>
          </div>
          <div v-if="quotaList.length === 0 && selectedDevice" class="quota-loading">加载中...</div>
          <div
            v-for="(item, index) in quotaList"
            :key="item.reagentId"
            class="reagent-quota-item"
          >
            <span class="reagent-index">{{ index + 1 }}</span>
            <span class="reagent-name">{{ item.reagentName }}</span>
            <div class="adjustment-controls">
              <el-button size="small"
                :disabled="!selectedDevice || tempAdjustments[item.reagentId] <= 0"
                @click="decrement(item.reagentId)">−</el-button>
              <el-input-number
                v-model="tempAdjustments[item.reagentId]"
                :min="0"
                :max="999"
                :precision="0"
                controls-position="right"
                size="small"
                class="adjust-input"
                :disabled="!selectedDevice"
                :controls="false"
              />
              <el-button size="small" :disabled="!selectedDevice" @click="increment(item.reagentId)">+</el-button>
            </div>
            <span class="quota-label"><strong>{{ item.quota }}</strong> 瓶</span>
            <span v-if="getAdjustment(item.reagentId) > 0" class="adjust-badge positive">
              +{{ getAdjustment(item.reagentId) }}瓶
            </span>
            <span v-else class="adjust-badge-placeholder">—</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="quota-actions" v-if="selectedDevice">
          <el-button @click="resetAdjustments">重置调整</el-button>
          <el-button type="primary" :disabled="!hasChanges" @click="showConfirmDialog">分配确认</el-button>
        </div>

        <!-- 分页 -->
        <div v-if="!selectedDevice && quotaCustomerList.length > 0" class="pagination">
          <el-pagination
            background
            @size-change="handleQuotaCustomerSizeChange"
            @current-change="handleQuotaCustomerCurrentChange"
            :current-page="quotaCustomerPage.current"
            :page-size="quotaCustomerPage.pageSize"
            :total="quotaCustomerPage.total"
            layout="total, sizes, prev, pager, next, jumper"
          />
        </div>
      </div>

    <!-- ========== 弹窗 ========== -->

    <!-- 详情弹窗 -->
    <el-dialog title="试剂详情" v-model="detailVisible" width="600px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="ID">{{ detailData.id }}</el-descriptions-item>
        <el-descriptions-item label="试剂名称">{{ detailData.name }}</el-descriptions-item>
        <el-descriptions-item label="规格">{{ detailData.specification || '-' }}</el-descriptions-item>
        <el-descriptions-item label="单位">{{ detailData.unit || '-' }}</el-descriptions-item>
        <el-descriptions-item label="总量">{{ detailData.totalAmount }} {{ detailData.unit }}</el-descriptions-item>
        <el-descriptions-item label="剩余量">
          <span :class="detailRemainPercent < 20 ? 'text-danger' : ''" style="font-weight:bold;">{{ detailData.remainAmount }} {{ detailData.unit }}</span>
          <span style="color:#909399;font-size:12px;margin-left:8px;">({{ detailRemainPercent }}%)</span>
        </el-descriptions-item>
        <el-descriptions-item label="批次号">{{ detailData.batchNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="生产厂家">{{ detailData.manufacturer || '-' }}</el-descriptions-item>
        <el-descriptions-item label="存储条件">{{ detailData.storageCondition || '-' }}</el-descriptions-item>
        <el-descriptions-item label="有效期">
          <span :class="isExpiring(detailData.expireDate) ? 'text-warning' : ''">{{ detailData.expireDate || '-' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailData.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detailData.createTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detailData.updateTime || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 新增/编辑试剂弹窗 -->
    <el-dialog :title="dialogMode === 'create' ? '新增试剂' : '编辑试剂'" v-model="dialogVisible" width="600px">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="试剂名称" prop="name">
          <el-select
            v-model="formData.name"
            filterable
            remote
            reserve-keyword
            placeholder="输入试剂名称搜索或直接选择"
            :remote-method="searchReagentSuggestions"
            :loading="reagentSuggestLoading"
            allow-create
            default-first-option
            style="width:100%;"
            @change="onReagentNameChange"
          >
            <el-option
              v-for="item in reagentSuggestions"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
              <span style="float:left">{{ item.name }}</span>
              <span style="float:right;color:#999;font-size:12px;">{{ item.specification || '无规格' }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格" prop="specification">
          <el-input v-model="formData.specification" placeholder="请输入规格" />
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input v-model="formData.unit" placeholder="如：mL、g、kg" />
        </el-form-item>
        <el-form-item label="总量" prop="totalAmount">
          <el-input-number v-model="formData.totalAmount" :min="0" :precision="2" style="width:100%;" />
        </el-form-item>
        <el-form-item label="批次号" prop="batchNo">
          <el-input v-model="formData.batchNo" placeholder="请输入批次号" />
        </el-form-item>
        <el-form-item label="生产厂家" prop="manufacturer">
          <el-input v-model="formData.manufacturer" placeholder="请输入生产厂家" />
        </el-form-item>
        <el-form-item label="存储条件" prop="storageCondition">
          <el-input v-model="formData.storageCondition" placeholder="如：2-8°C冷藏" />
        </el-form-item>
        <el-form-item label="有效期" prop="expireDate">
          <el-date-picker v-model="formData.expireDate" type="date" placeholder="选择有效期"
            value-format="YYYY-MM-DD" style="width:100%;" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="formData.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 试剂出库弹窗（Tab1用） -->
    <el-dialog title="试剂出库" v-model="outDialogVisible" width="500px">
      <el-form :model="outFormData" :rules="outRules" ref="outFormRef" label-width="100px">
        <el-form-item label="试剂名称">
          <el-input v-model="outFormData.reagentName" disabled />
        </el-form-item>
        <el-form-item label="当前库存">
          <el-input v-model="outFormData.remainAmountText" disabled />
        </el-form-item>
        <el-form-item label="出库数量" prop="outAmount">
          <el-input-number v-model="outFormData.outAmount" :min="0.01" :max="outFormData.maxAmount" :precision="2"
            style="width:100%;" />
          <div style="color:#909399;font-size:12px;margin-top:4px;">最大可出库：{{ outFormData.maxAmount }}</div>
        </el-form-item>
        <el-form-item label="出库类型" prop="outType">
          <el-select v-model="outFormData.outType" placeholder="请选择出库类型" style="width:100%;">
            <el-option label="常规出库" value="常规出库" />
            <el-option label="损耗出库" value="损耗出库" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="outFormData.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="outDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleOutSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 试剂分配确认弹窗 -->
    <el-dialog :title="'试剂分配确认（' + (selectedCustomer ? selectedCustomer.userName + ' ' + selectedCustomer.phone : '') + '）'"
      v-model="confirmDialogVisible" width="700px">
      <div class="confirm-info">请核对以下试剂额度调整，确认无误后点击"确认分配"：</div>
      <el-table :data="confirmTableData" border size="small" class="confirm-table">
        <el-table-column type="index" label="序号" width="120" align="center" />
        <el-table-column prop="reagentName" label="试剂名称" width="120"/>
        <el-table-column label="调整数量" width="120" align="center">
          <template v-slot="scope"><span class="text-success">+{{ scope.row.change }}瓶</span></template>
        </el-table-column>
        <el-table-column label="当前额度" width="120" align="center">
          <template v-slot="scope">{{ scope.row.currentQuota }} 瓶</template>
        </el-table-column>
        <el-table-column label="本次调整后" width="120" align="center">
          <template v-slot="scope"><strong>{{ scope.row.newQuota }}</strong> 瓶</template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="confirmDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="allocating" @click="submitAllocation">确认分配</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchReagentPage, getReagentById, createReagent, updateReagent, deleteReagent,
  createReagentOut, fetchReagentOutPage, deleteReagentOut, revokeReagentOut,
  queryReagentByName,
} from "@/api/reagent";
import {
  searchCustomerQuotaPage, getCustomerQuotaById, allocateReagentQuota,
} from "@/api/reagentQuota";

export default {
  data() {
    return {
      permission: null,
      activeTab: "manage",
      manageLoaded: false,
      recordLoaded: false,
      outLoaded: false,

      // ========== Tab1: 试剂管理 ==========
      manageSearch: { name: "", batchNo: "", sortOrder: "desc" },
      manageList: [],
      managePage: { current: 1, pageSize: 10, total: 0 },

      // ========== Tab2: 出库记录 ==========
      recordSearch: { reagentName: "", operatorName: "", dateRange: [], customerName: "", customerPhone: "", deviceCode: "" },
      recordList: [],
      recordPage: { current: 1, pageSize: 10, total: 0 },

      // ========== Tab3: 出库管理 ==========
      quotaSearch: { phone: "", userName: "", deviceCode: "" },
      quotaSearchLoading: false,
      quotaSearched: false,
      quotaCustomerList: [],
      quotaCustomerPage: { current: 1, pageSize: 10, total: 0 },
      selectedDevice: null,
      quotaList: [],
      tempAdjustments: {},
      confirmDialogVisible: false,
      allocating: false,

      // ========== 详情 ==========
      detailVisible: false,
      detailData: {},

      // ========== 新增/编辑弹窗 ==========
      dialogVisible: false,
      dialogMode: "create",
      formData: this.getEmptyForm(),
      rules: { name: [{ required: true, message: "请输入试剂名称", trigger: "blur" }] },
      reagentSuggestions: [],
      reagentSuggestLoading: false,

      // ========== 试剂出库弹窗（Tab1用） ==========
      outDialogVisible: false,
      outFormData: this.getEmptyOutForm(),
      outRules: {
        outAmount: [{ required: true, message: "请输入出库数量", trigger: "blur" }],
        outType: [{ required: true, message: "请选择出库类型", trigger: "change" }],
      },
    };
  },
  computed: {
    detailRemainPercent() {
      if (!this.detailData.totalAmount) return 0;
      return Math.round((this.detailData.remainAmount / this.detailData.totalAmount) * 100);
    },
    hasChanges() {
      return Object.values(this.tempAdjustments).some(v => v > 0);
    },
    confirmTableData() {
      return this.quotaList
        .filter(item => this.tempAdjustments[item.reagentId] > 0)
        .map((item, idx) => ({
          index: idx + 1,
          reagentName: item.reagentName,
          change: this.tempAdjustments[item.reagentId],
          currentQuota: item.quota,
          newQuota: item.quota + this.tempAdjustments[item.reagentId],
        }));
    },
    isSuperAdmin() {
      return this.permission === 0;
    },
    selectedCustomer() {
      return this.selectedDevice;
    },
  },
  methods: {
    // ========== Tab1: 试剂管理 ==========
    handleManageSizeChange(size) {
      this.managePage.pageSize = size;
      this.managePage.current = 1;
      this.searchManage();
    },
    handleManageCurrentChange(page) {
      this.managePage.current = page;
      this.searchManage();
    },
    async searchManage() {
      console.info("[FE-试剂管理] 查询列表请求: name=%s, batchNo=%s, sortField=%s, sortOrder=%s, current=%d, pageSize=%d",
        this.manageSearch.name, this.manageSearch.batchNo,
        this.manageSearch.sortField, this.manageSearch.sortOrder,
        this.managePage.current, this.managePage.pageSize);
      try {
        const res = await fetchReagentPage({
          name: this.manageSearch.name,
          batchNo: this.manageSearch.batchNo,
          sortOrder: this.manageSearch.sortOrder,
          current: this.managePage.current,
          pageSize: this.managePage.pageSize,
        });
        console.info("[FE-试剂管理] 查询列表响应: code=%d, total=%d, records=%d",
          res.code, res.data?.total, res.data?.records?.length);
        if (res.code === 200) {
          this.manageList = res.data.records;
          this.managePage.total = res.data.total;
        } else {
          console.warn("[FE-试剂管理] 查询列表失败: code=%d, message=%s", res.code, res.message);
        }
      } catch (e) { console.error("[FE-试剂管理] 查询列表异常: %o", e); }
    },

    // ========== Tab2: 出库记录 ==========
    getRecordCell({ columnIndex }) {
      // 第1列（reagentName）右侧收紧，第2列（outAmount）左侧收紧
      if (columnIndex === 1) return 'record-cell-tight-right';
      if (columnIndex === 2) return 'record-cell-tight-left';
      return '';
    },
    handleRecordSizeChange(size) {
      this.recordPage.pageSize = size;
      this.recordPage.current = 1;
      this.searchRecord();
    },
    handleRecordCurrentChange(page) {
      this.recordPage.current = page;
      this.searchRecord();
    },
    async searchRecord() {
      console.info("[FE-出库记录] 查询列表请求: reagentName=%s, operatorName=%s, startTime=%s, endTime=%s, customerName=%s, customerPhone=%s, deviceCode=%s, current=%d, pageSize=%d",
        this.recordSearch.reagentName, this.recordSearch.operatorName,
        this.recordSearch.dateRange?.[0], this.recordSearch.dateRange?.[1],
        this.recordSearch.customerName, this.recordSearch.customerPhone, this.recordSearch.deviceCode,
        this.recordPage.current, this.recordPage.pageSize);
      try {
        const res = await fetchReagentOutPage({
          reagentName: this.recordSearch.reagentName,
          operatorName: this.recordSearch.operatorName,
          startTime: this.recordSearch.dateRange?.[0] || undefined,
          endTime: this.recordSearch.dateRange?.[1] || undefined,
          customerName: this.recordSearch.customerName,
          customerPhone: this.recordSearch.customerPhone,
          deviceCode: this.recordSearch.deviceCode,
          current: this.recordPage.current,
          pageSize: this.recordPage.pageSize,
        });
        console.info("[FE-出库记录] 查询列表响应: code=%d, total=%d, records=%d",
          res.code, res.data?.total, res.data?.records?.length);
        if (res.code === 200) {
          this.recordList = res.data.records;
          this.recordPage.total = res.data.total;
        } else {
          console.warn("[FE-出库记录] 查询列表失败: code=%d, message=%s", res.code, res.message);
        }
      } catch (e) { console.error("[FE-出库记录] 查询列表异常: %o", e); }
    },

    async confirmRevokeRecord(row) {
      console.info("[FE-出库记录] 确认撤销请求: recordId=%d, reagentName=%s, outAmount=%s, customerId=%s, deviceId=%s",
        row.id, row.reagentName, row.outAmount, row.customerId, row.deviceId);
      try {
        await this.$confirm("确定要撤销该出库记录吗？撤销后将恢复试剂库存和客户配额。", "确认撤销", { type: "warning" });
        await this.revokeOutRecord(row);
        console.info("[FE-出库记录] 撤销成功: recordId=%d", row.id);
        this.$message.success("撤销成功");
        await this.searchRecord();
        if (this.manageLoaded) this.searchManage();
        if (this.selectedDevice && this.selectedDevice.customerId === row.customerId && this.selectedDevice.deviceId === row.deviceId) {
          await this.selectDevice(this.selectedDevice);
        }
      } catch (e) {
        if (e !== "cancel") {
          console.error("[FE-出库记录] 撤销失败: recordId=%d, error=%o", row.id, e);
        }
      }
    },

    async revokeOutRecord(row) {
      console.info("[FE-出库记录] 调用撤销API: recordId=%d", row.id);
      const res = await revokeReagentOut(row.id);
      console.info("[FE-出库记录] 撤销API响应: recordId=%d, code=%d, message=%s", row.id, res.code, res.message);
      if (res.code !== 200) throw new Error(res.message || "撤销失败");
      return row;
    },

    // ========== Tab3: 出库管理 ==========
    handleQuotaCustomerSizeChange(size) {
      this.quotaCustomerPage.pageSize = size;
      this.quotaCustomerPage.current = 1;
      this.searchQuotaCustomers();
    },
    handleQuotaCustomerCurrentChange(page) {
      this.quotaCustomerPage.current = page;
      this.searchQuotaCustomers();
    },
    async searchQuotaCustomers() {
      if (!this.quotaSearch.phone && !this.quotaSearch.userName && !this.quotaSearch.deviceCode) {
        this.$message.warning("请填写至少一项搜索条件");
        return;
      }
      this.quotaSearchLoading = true;
      this.quotaSearched = true;
      console.info("[FE-出库管理] 搜索客户请求: phone=%s, userName=%s, deviceCode=%s, current=%d, pageSize=%d",
        this.quotaSearch.phone, this.quotaSearch.userName, this.quotaSearch.deviceCode,
        this.quotaCustomerPage.current, this.quotaCustomerPage.pageSize);
      try {
        const res = await searchCustomerQuotaPage({
          phone: this.quotaSearch.phone,
          userName: this.quotaSearch.userName,
          deviceCode: this.quotaSearch.deviceCode,
          current: this.quotaCustomerPage.current,
          pageSize: this.quotaCustomerPage.pageSize,
        });
        console.info("[FE-出库管理] 搜索客户响应: code=%d, total=%d, records=%d",
          res.code, res.data?.total, res.data?.records?.length);
        if (res.code === 200) {
          this.quotaCustomerList = res.data.records;
          this.quotaCustomerPage.total = res.data.total;
        } else {
          console.warn("[FE-出库管理] 搜索客户失败: code=%d, message=%s", res.code, res.message);
        }
      } catch (e) { console.error("[FE-出库管理] 搜索客户异常: %o", e); }
      finally { this.quotaSearchLoading = false; }
    },

    async selectDevice(row) {
      this.selectedDevice = row;
      this.tempAdjustments = {};
      console.info("[FE-出库管理] 选择设备请求: customerId=%s, deviceId=%s, deviceName=%s",
        row.customerId, row.deviceId, row.deviceName);
      try {
        const res = await getCustomerQuotaById(row.customerId, row.deviceId, row.deviceName || '');
        console.info("[FE-出库管理] 选择设备响应: customerId=%s, deviceId=%s, code=%d, quotaCount=%d",
          row.customerId, row.deviceId, res.code, res.data?.quotas?.length);
        if (res.code === 200) {
          this.quotaList = res.data.quotas || [];
          this.tempAdjustments = {};
          this.quotaList.forEach(item => {
            this.tempAdjustments[item.reagentId] = 0;
          });
        } else {
          console.warn("[FE-出库管理] 选择设备失败: customerId=%s, deviceId=%s, code=%d, message=%s",
            row.customerId, row.deviceId, res.code, res.message);
        }
      } catch (e) { console.error("[FE-出库管理] 选择设备异常: customerId=%s, deviceId=%s, error=%o", row.customerId, row.deviceId, e); }
    },

    increment(reagentId) {
      if (!this.tempAdjustments[reagentId]) {
        this.tempAdjustments[reagentId] = 0;
      }
      this.tempAdjustments[reagentId]++;
    },
    decrement(reagentId) {
      if (!this.tempAdjustments[reagentId]) {
        this.tempAdjustments[reagentId] = 0;
      }
      if (this.tempAdjustments[reagentId] > 0) {
        this.tempAdjustments[reagentId]--;
      }
    },
    getAdjustment(reagentId) {
      return this.tempAdjustments[reagentId] || 0;
    },
    clearDevice() {
      this.selectedDevice = null;
      this.quotaList = [];
      this.tempAdjustments = {};
    },
    resetAdjustments() {
      this.tempAdjustments = {};
    },
    showConfirmDialog() {
      if (!this.hasChanges) return;
      this.confirmDialogVisible = true;
    },
    async submitAllocation() {
      const changes = Object.entries(this.tempAdjustments)
        .filter(([, v]) => v > 0)
        .map(([reagentId, change]) => ({
          reagentId: Number(reagentId),
          change,
        }));
      if (changes.length === 0) return;
      console.info("[FE-出库管理] 提交分配请求: customerId=%s, deviceId=%s, changes=%o",
        this.selectedDevice.customerId, this.selectedDevice.deviceId, changes);
      this.allocating = true;
      try {
        const res = await allocateReagentQuota({
          customerId: this.selectedDevice.customerId,
          deviceId: this.selectedDevice.deviceId,
          deviceName: this.selectedDevice.deviceName || '',
          changes,
        });
        console.info("[FE-出库管理] 提交分配响应: code=%d, message=%s", res.code, res.message);
        this.$message.success("分配成功");
        this.confirmDialogVisible = false;
        this.tempAdjustments = {};
        await this.selectDevice(this.selectedDevice);
      } catch (e) {
        console.error("[FE-出库管理] 提交分配失败: customerId=%s, deviceId=%s, error=%o",
          this.selectedDevice.customerId, this.selectedDevice.deviceId, e);
      }
      finally { this.allocating = false; }
    },

    // ========== 详情 ==========
    async showDetailDialog(row) {
      console.info("[FE-试剂管理] 查询详情请求: reagentId=%d, name=%s", row.id, row.name);
      try {
        const res = await getReagentById(row.id);
        console.info("[FE-试剂管理] 查询详情响应: reagentId=%d, code=%d", row.id, res.code);
        if (res.code === 200) {
          this.detailData = res.data;
          this.detailVisible = true;
        } else {
          console.warn("[FE-试剂管理] 查询详情失败: reagentId=%d, code=%d, message=%s", row.id, res.code, res.message);
        }
      } catch (e) { console.error("[FE-试剂管理] 查询详情异常: reagentId=%d, error=%o", row.id, e); }
    },

    // ========== 新增/编辑 ==========
    async searchReagentSuggestions(query) {
      if (!query) {
        this.reagentSuggestions = [];
        return;
      }
      this.reagentSuggestLoading = true;
      try {
        const res = await queryReagentByName(query);
        if (res.code === 200) {
          this.reagentSuggestions = res.data.records || [];
        }
      } catch (e) {
        console.error("[FE-试剂管理] 搜索建议异常: %o", e);
      } finally {
        this.reagentSuggestLoading = false;
      }
    },
    onReagentNameChange(name) {
      const matched = this.reagentSuggestions.find(r => r.name === name);
      if (matched) {
        this.formData.specification = matched.specification || "";
        this.formData.unit = matched.unit || "";
        this.formData.manufacturer = matched.manufacturer || "";
      }
    },
    showCreateDialog() {
      this.dialogMode = "create";
      this.formData = this.getEmptyForm();
      if (this.$refs.formRef) this.$refs.formRef.resetFields();
      this.dialogVisible = true;
    },
    showEditDialog(row) {
      this.dialogMode = "edit";
      this.formData = {
        id: row.id, name: row.name, specification: row.specification, unit: row.unit,
        totalAmount: row.totalAmount, batchNo: row.batchNo, manufacturer: row.manufacturer,
        storageCondition: row.storageCondition,
        expireDate: row.expireDate ? row.expireDate.substring(0, 10) : "", remark: row.remark,
        remainAmount: row.remainAmount,
      };
      this.dialogVisible = true;
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        if (this.dialogMode === "create") {
          console.info("[FE-试剂管理] 新增试剂请求: %o", this.formData);
          const res = await createReagent(this.formData);
          console.info("[FE-试剂管理] 新增试剂响应: code=%d, message=%s", res.code, res.message);
          if (res.code !== 200) throw new Error(res.message || "新增失败");
          this.$message.success("新增成功");
        } else {
          console.info("[FE-试剂管理] 编辑试剂请求: %o", this.formData);
          const res = await updateReagent(this.formData);
          console.info("[FE-试剂管理] 编辑试剂响应: code=%d, message=%s", res.code, res.message);
          if (res.code !== 200) throw new Error(res.message || "更新失败");
          this.$message.success("更新成功");
        }
        this.dialogVisible = false;
        this.searchManage();
      } catch (e) { if (e !== false) console.error("[FE-试剂管理] 提交失败: mode=%s, error=%o", this.dialogMode, e); }
    },

    // ========== 试剂出库（Tab1用） ==========
    showOutDialog(row) {
      this.outFormData = {
        reagentId: row.id, reagentName: row.name,
        remainAmountText: row.remainAmount + " " + (row.unit || ""),
        maxAmount: row.remainAmount, outAmount: 1, outType: "常规出库",
        customerId: this.selectedDevice ? this.selectedDevice.customerId : null,
        deviceId: this.selectedDevice ? this.selectedDevice.deviceId : null,
        remark: "",
      };
      if (this.$refs.outFormRef) this.$refs.outFormRef.resetFields();
      this.outDialogVisible = true;
    },
    async handleOutSubmit() {
      console.info("[FE-试剂管理] 出库请求: reagentId=%d, reagentName=%s, outAmount=%s, outType=%s, customerId=%s, deviceId=%s",
        this.outFormData.reagentId, this.outFormData.reagentName, this.outFormData.outAmount,
        this.outFormData.outType, this.outFormData.customerId, this.outFormData.deviceId);
      try {
        await this.$refs.outFormRef.validate();
        const res = await createReagentOut({
          reagentId: this.outFormData.reagentId,
          reagentName: this.outFormData.reagentName,
          outAmount: this.outFormData.outAmount,
          outType: this.outFormData.outType,
          customerId: this.outFormData.customerId,
          deviceId: this.outFormData.deviceId,
          remark: this.outFormData.remark,
        });
        console.info("[FE-试剂管理] 出库响应: code=%d, message=%s", res.code, res.message);
        this.$message.success("出库成功");
        this.outDialogVisible = false;
        this.searchManage();
      } catch (e) {
        if (e !== false) console.error("[FE-试剂管理] 出库异常: reagentId=%d, error=%o", this.outFormData.reagentId, e);
      }
    },

    // ========== 删除 ==========
    async confirmDelete(id) {
      console.info("[FE-试剂管理] 确认删除试剂: reagentId=%d", id);
      try {
        await this.$confirm("确定要删除该试剂吗？", "确认删除", { type: "warning" });
        const res = await deleteReagent(id);
        console.info("[FE-试剂管理] 删除试剂响应: reagentId=%d, code=%d, message=%s", id, res.code, res.message);
        if (res.code !== 200) throw new Error(res.message || "删除失败");
        this.$message.success("删除成功");
        this.searchManage();
      } catch (e) {
        if (e !== "cancel") console.error("[FE-试剂管理] 删除试剂失败: reagentId=%d, error=%o", id, e);
      }
    },
    async confirmDeleteRecord(id) {
      console.info("[FE-出库记录] 确认删除记录: recordId=%d", id);
      try {
        await this.$confirm("确定要删除该出库记录吗？", "确认删除", { type: "warning" });
        const res = await deleteReagentOut(id);
        console.info("[FE-出库记录] 删除记录响应: recordId=%d, code=%d, message=%s", id, res.code, res.message);
        if (res.code !== 200) throw new Error(res.message || "删除失败");
        this.$message.success("删除成功");
        this.searchRecord();
      } catch (e) {
        if (e !== "cancel") console.error("[FE-出库记录] 删除记录失败: recordId=%d, error=%o", id, e);
      }
    },

    // ========== 工具方法 ==========
    isExpiring(expireDate) {
      if (!expireDate) return false;
      const diff = (new Date(expireDate) - new Date()) / (1000 * 60 * 60 * 24);
      return diff <= 30 && diff > 0;
    },
    getEmptyForm() {
      return { name: "", specification: "", unit: "", totalAmount: 0, batchNo: "",
        manufacturer: "", storageCondition: "", expireDate: "", remark: "" };
    },
    getEmptyOutForm() {
      return { reagentId: null, reagentName: "", remainAmountText: "", maxAmount: 0,
        outAmount: 1, outType: "常规出库", remark: "" };
    },
  },
  created() {
    const permStr = localStorage.getItem("permission");
    this.permission = permStr != null ? Number(permStr) : null;
    if (this.permission !== 0) {
      this.$message.error("仅超级管理员可使用试剂管理功能");
      this.$router.replace("/home");
      return;
    }
    // 支持通过 ?tab= 参数直接切换到指定 tab
    const tab = this.$route.query.tab;
    if (tab && ['manage', 'record', 'out'].includes(tab)) {
      this.activeTab = tab;
    }
    this.searchManage();
    this.manageLoaded = true;
  },
  watch: {
    '$route.query.tab'(newTab) {
      if (newTab && ['manage', 'record', 'out'].includes(newTab)) {
        this.activeTab = newTab;
        // 懒加载：首次切换到某个 tab 时加载数据
        if (newTab === 'manage' && !this.manageLoaded) {
          this.manageLoaded = true;
          this.searchManage();
        } else if (newTab === 'record' && !this.recordLoaded) {
          this.recordLoaded = true;
          this.searchRecord();
        } else if (newTab === 'out' && !this.outLoaded) {
          this.outLoaded = true;
        }
      } else {
        // 无 tab 参数（点击一级"试剂管理"时），重置为 manage
        this.activeTab = 'manage';
      }
    },
  },
};
</script>

<style scoped>
.reagent-tabs { margin-top: -10px; }
.search-bar { margin-bottom: 16px; }
.pagination { margin-top: 16px; display: flex; justify-content: flex-end; }
.text-warning { color: #e6a23c; font-weight: bold; }
.text-danger { color: #f56c6c; font-weight: bold; }
.text-success { color: #67c23a; font-weight: bold; }

/* Tab3 样式 */
.quota-section { padding-top: 4px; }
.customer-info-card { margin-bottom: 20px; background: #f5f7fa; border: 1px solid #e4e7ed; }
.info-label { color: #909399; font-size: 13px; }
.info-value { color: #303133; font-weight: 500; font-size: 13px; }

.reagent-quota-list { margin-bottom: 20px; width: 100%; max-width: 500px; }
.reagent-quota-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid #f0f0f0;
  gap: 12px; box-sizing: border-box; width: 100%;
}
.reagent-quota-item:last-child { border-bottom: none; }
.reagent-index {
  width: 22px; height: 22px; background: #409eff; color: #fff;
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
  font-size: 12px; flex-shrink: 0;
}
.reagent-name { flex: 1; font-weight: 500; color: #303133; min-width: 95px !important; max-width: none !important; box-sizing: border-box; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.adjustment-controls { display: flex; align-items: center; gap: 4px; width: 95px !important; min-width: 95px !important; max-width: 95px !important; justify-content: center; box-sizing: border-box; flex-shrink: 0; }
.adjust-input { width: 50px !important; min-width: 50px !important; max-width: 50px !important; box-sizing: border-box; }
.adjust-input .el-input__wrapper { padding: 0 4px !important; width: 100% !important; box-sizing: border-box; }
.adjust-input .el-input__inner { width: 100% !important; min-width: unset !important; text-align: center; padding: 0; }
.quota-label { color: #909399; font-size: 13px; white-space: nowrap; width: 95px !important; min-width: 95px !important; max-width: 95px !important; text-align: center; flex-shrink: 0; box-sizing: border-box; }
.adjust-badge {
  display: inline-block; width: 95px !important; min-width: 95px !important; max-width: 95px !important;
  text-align: center; flex-shrink: 0; box-sizing: border-box;
  padding: 2px 8px; border-radius: 10px; font-size: 12px; font-weight: bold;
}
.adjust-badge.positive { background: #f0f9eb; color: #67c23a; border: 1px solid #e1f3d8; }
.adjust-badge.negative { background: #fef0f0; color: #f56c6c; border: 1px solid #fde2e2; }
.adjust-badge-placeholder { display: inline-block; width: 95px !important; min-width: 95px !important; max-width: 95px !important; text-align: center; flex-shrink: 0; box-sizing: border-box; color: #d0d0d0; font-size: 13px; }

.quota-actions { display: flex; justify-content: center; gap: 16px; padding: 12px 0; }

.confirm-info { margin-bottom: 14px; color: #606266; font-size: 13px; }

/* 新布局样式 */
.quota-list-header {
  display: flex; align-items: center; padding: 8px 14px;
  background: #f5f7fa; border: 1px solid #e4e7ed; border-bottom: none;
  font-size: 13px; color: #909399; font-weight: 500;
  gap: 12px; box-sizing: border-box; width: 100%;
}
.qh-index { width: 22px; text-align: center; flex-shrink: 0; }
.qh-name { flex: 1; min-width: 95px !important; }
.qh-controls { width: 95px !important; min-width: 95px !important; max-width: 95px !important; text-align: center; flex-shrink: 0; box-sizing: border-box; }
.qh-current { width: 95px !important; min-width: 95px !important; max-width: 95px !important; text-align: center; flex-shrink: 0; box-sizing: border-box; }
.qh-change { width: 95px !important; min-width: 95px !important; max-width: 95px !important; text-align: center; flex-shrink: 0; box-sizing: border-box; }

.reagent-quota-list.disabled { opacity: 0.5; pointer-events: none; user-select: none; }

.selected-customer-bar {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 16px; background: #f0f9eb; border: 1px solid #c2e7b0;
  border-radius: 4px; margin-bottom: 12px;
}
.selected-customer-info { display: flex; align-items: center; gap: 8px; }
.sc-label { color: #67c23a; font-weight: 500; }
.sc-name { font-weight: 600; color: #303133; }
.sc-phone { color: #606266; }

.quota-empty-tip {
  text-align: center; color: #909399; padding: 24px 0; font-size: 13px;
}

.quota-loading { text-align: center; color: #909399; padding: 16px 0; font-size: 13px; }

.confirm-table .el-table__header-wrapper th { text-align: center; }
.confirm-table .el-table__body-wrapper td { text-align: center; }
.confirm-table .cell { padding: 0 8px; }

/* 出库记录表格：试剂名称和出库数量列间距收紧 */
.record-table .el-table__body td.record-cell-tight-right .cell { padding-right: 4px; }
.record-table .el-table__body td.record-cell-tight-left .cell { padding-left: 4px; }
</style>
